import React, { Component } from 'react'
import { Row, Col, Carousel } from 'antd'
import { observer, inject } from 'mobx-react'

@inject(
  'templateStore',
  'webSettingStore',
  'CmsFacilityHotelStore',
  'CmsEventHotelStore',
  'homeSpecialOfferStore',
  'homeRetailOfferStore',
  'CmsClimateStore'
)
@observer
class HomeCarouselThemeTwo extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount() {
    this.props.CmsFacilityHotelStore.getAllByLanguage();
    this.props.CmsEventHotelStore.getAllByLanguage();
    this.props.homeSpecialOfferStore.initAvailable();
    this.props.homeRetailOfferStore.initAvailable();
    this.props.CmsClimateStore.getData();
  }

  getTitleOnRender = () => {
    let title = localStorage.getItem('title');

    if (title) {
      if (title !== 'null') {
        return title.replace(/^"(.*)"$/, '$1');
      }
    }

    return '';
  }

  hotelFacilityOnClick = (id) => {
    this.props.history.push(`/facility/${id}`);
  }

  hotelEventOnClick = (id) => {
    this.props.history.push(`/event/${id}`);
  }

  specialOfferOnClick = (id) => {
    this.props.history.push(`/special-offer/${id}`);
  }

  retailOfferOnClick = (id) => {
    this.props.history.push(`/retail-offer/${id}`);
  }

  render() {
    const { activeTemplate } = this.props.templateStore;
    const { data: webSetting } = this.props.webSettingStore;
    const lang = window.localStorage.getItem('lang') || 'en';
    const title = this.getTitleOnRender();
    const lastName = JSON.parse(localStorage.getItem('lastName'));
    const roomNo = JSON.parse(localStorage.getItem('roomNo'));
    const { temp } = this.props.CmsClimateStore;
    const { facilityHotels } = this.props.CmsFacilityHotelStore;
    const { eventHotels } = this.props.CmsEventHotelStore;
    const { specialOffers } = this.props.homeSpecialOfferStore;
    const { retailOffers } = this.props.homeRetailOfferStore;

    return (
      <>
        {
          activeTemplate
            ?
            <>
              {
                webSetting
                  ?
                  <>
                    <Carousel
                      autoplay
                      autoplaySpeed={8000}
                      style={{
                        background: activeTemplate.templateSetting.header.backgroundColor
                      }}
                    >
                      {/* Home */}
                      <>
                        <Row>
                          <Col
                            span={24}
                            className='stm-height-50-vh stm-background-size-cover'
                            style={{
                              background: webSetting.homeImageUrl ? `url(${webSetting.homeImageUrl})` : 'black'
                            }}
                          >
                            <Row>
                              <Col span={24} className='stm-text-align-center stm-height-100 stm-margin-top-32'>
                                <>
                                  {
                                    webSetting.logoImageUrl
                                      ?
                                      <img src={webSetting.logoImageUrl} alt='Logo' className='stm-height-100 stm-width-auto stm-margin-auto' />
                                      :
                                      null
                                  }
                                </>
                              </Col>
                              <Col span={24} className='stm-margin-top-32'>
                                <Row>
                                  <Col span={12} className='stm-home-theme-two-info-left'>
                                    {webSetting.welcomeText}<br />
                                    {title} {lastName}
                                  </Col>
                                  <Col
                                    span={12} className='stm-home-theme-two-info-right'
                                    style={{
                                      fontFamily: activeTemplate.templateSetting.homeHeader.fontFamily,
                                      color: activeTemplate.templateSetting.homeHeader.color,
                                    }}
                                  >
                                    <span
                                      className=''
                                      style={{
                                        fontSize: activeTemplate.templateSetting.homeHeader.fontSize,
                                        lineHeight: `${activeTemplate.templateSetting.homeHeader.fontSize + 2}px`
                                      }}
                                    >{webSetting.roomText} {roomNo}</span><br />
                                    <span
                                      className=''
                                      style={{
                                        fontSize: activeTemplate.templateSetting.homeInfo.fontSize,
                                        lineHeight: `${activeTemplate.templateSetting.homeInfo.fontSize + 2}px`
                                      }}
                                    >{temp}°C</span>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </>

                      {/* Hotel Facilities */}
                      {
                        facilityHotels.map(item => {
                          let firstImageUrl = '';
                          try {
                            let images = JSON.parse(item.bannerUrl);
                            firstImageUrl = images[0].url;
                          } catch {
                            firstImageUrl = item.bannerUrl;
                          }

                          return (
                            <Row
                              key={item.id}>
                              <Col
                                span={24}
                                className='stm-height-50-vh stm-background-size-cover'
                                style={{ backgroundImage: 'url("' + firstImageUrl + '")' }}
                                onClick={() => this.hotelFacilityOnClick(item.id)}>
                                <Row>
                                  <Col span={18} className='stm-home-theme-two-info-content'>
                                    <span
                                      style={{
                                        fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                        color: activeTemplate.templateSetting.label.color,
                                        fontSize: activeTemplate.templateSetting.label.fontSize,
                                        lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                      }}
                                    >{item.title}</span>
                                    <br />
                                    <span
                                      style={{
                                        fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                        color: activeTemplate.templateSetting.text.color,
                                        fontSize: activeTemplate.templateSetting.text.fontSize,
                                        lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`
                                      }}
                                    >{item.briefDescription}</span>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          )
                        })
                      }

                      {/* Hotel Event */}
                      {
                        eventHotels.map(item => {
                          let firstImageUrl = '';
                          try {
                            let images = JSON.parse(item.bannerUrl);
                            firstImageUrl = images[0].url;
                          } catch {
                            firstImageUrl = item.bannerUrl;
                          }

                          return (
                            <Row
                              key={item.id}>
                              <Col
                                span={24}
                                className='stm-height-50-vh stm-background-size-cover'
                                style={{ backgroundImage: 'url("' + firstImageUrl + '")' }}
                                onClick={() => this.hotelEventOnClick(item.id)}>
                                <Row>
                                  <Col span={18} className='stm-home-theme-two-info-content'>
                                    <span
                                      style={{
                                        fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                        color: activeTemplate.templateSetting.label.color,
                                        fontSize: activeTemplate.templateSetting.label.fontSize,
                                        lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                      }}
                                    >{item.title}</span>
                                    <br />
                                    <span
                                      style={{
                                        fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                        color: activeTemplate.templateSetting.text.color,
                                        fontSize: activeTemplate.templateSetting.text.fontSize,
                                        lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`
                                      }}
                                    >{item.briefDescription}</span>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          )
                        })
                      }

                      {/* F&B Offer */}
                      {
                        specialOffers.map(specialOffer => {
                          let briefDescText = ''
                          let titleText = ''

                          if (lang === 'en') {
                            briefDescText = specialOffer.briefDesc
                            titleText = specialOffer.title
                          } else if (lang === 'zh') {
                            briefDescText = specialOffer.briefDescLang.chinese
                            titleText = specialOffer.titleLang.chinese
                          } else if (lang === 'zh-Hant') {
                            briefDescText = specialOffer.briefDescLang.chineseTraditional
                            titleText = specialOffer.titleLang.chineseTraditional
                          } else if (lang === 'th') {
                            briefDescText = specialOffer.briefDescLang.thai
                            titleText = specialOffer.titleLang.thai
                          } else if (lang === 'ja') {
                            briefDescText = specialOffer.briefDescLang.japanese
                            titleText = specialOffer.titleLang.japanese
                          } else if (lang === 'es') {
                            briefDescText = specialOffer.briefDescLang.spanish
                            titleText = specialOffer.titleLang.spanish
                          }

                          if (briefDescText === '') {
                            briefDescText = specialOffer.briefDesc;
                          }
                          if (titleText === '') {
                            titleText = specialOffer.title;
                          }

                          let firstImageUrl = '';
                          try {
                            let images = JSON.parse(specialOffer.imageUrl);
                            firstImageUrl = images[0].url;
                          } catch {
                            firstImageUrl = specialOffer.imageUrl;
                          }

                          return (
                            <Row
                              key={specialOffer.specialOfferId}>
                              <Col
                                span={24}
                                className='stm-height-50-vh stm-background-size-cover'
                                style={{ backgroundImage: 'url("' + firstImageUrl + '")' }}
                                onClick={() => this.specialOfferOnClick(specialOffer.specialOfferId)}>
                                <Row>
                                  <Col span={18} className='stm-home-theme-two-info-content'>
                                    <span
                                      style={{
                                        fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                        color: activeTemplate.templateSetting.label.color,
                                        fontSize: activeTemplate.templateSetting.label.fontSize,
                                        lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                      }}
                                    >{titleText}</span>
                                    <br />
                                    <span
                                      style={{
                                        fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                        color: activeTemplate.templateSetting.text.color,
                                        fontSize: activeTemplate.templateSetting.text.fontSize,
                                        lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`
                                      }}
                                    >{briefDescText}</span>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          )
                        })
                      }

                      {/* Retail Offers */}
                      {
                        retailOffers.map(retailOffer => {
                          let briefDescText = ''
                          let titleText = ''

                          if (lang === 'en') {
                            briefDescText = retailOffer.briefDesc
                            titleText = retailOffer.title
                          } else if (lang === 'zh') {
                            briefDescText = retailOffer.briefDescLang.chinese
                            titleText = retailOffer.titleLang.chinese
                          } else if (lang === 'zh-Hant') {
                            briefDescText = retailOffer.briefDescLang.chineseTraditional
                            titleText = retailOffer.titleLang.chineseTraditional
                          } else if (lang === 'th') {
                            briefDescText = retailOffer.briefDescLang.thai
                            titleText = retailOffer.titleLang.thai
                          } else if (lang === 'ja') {
                            briefDescText = retailOffer.briefDescLang.japanese
                            titleText = retailOffer.titleLang.japanese
                          } else if (lang === 'es') {
                            briefDescText = retailOffer.briefDescLang.spanish
                            titleText = retailOffer.titleLang.spanish
                          }

                          if (briefDescText === '') {
                            briefDescText = retailOffer.briefDesc;
                          }
                          if (titleText === '') {
                            titleText = retailOffer.title;
                          }

                          let firstImageUrl = '';
                          try {
                            let images = JSON.parse(retailOffer.imageUrl);
                            firstImageUrl = images[0].url;
                          } catch {
                            firstImageUrl = retailOffer.imageUrl;
                          }

                          return (
                            <Row
                              key={retailOffer.retailOfferId}>
                              <Col
                                span={24}
                                className='stm-height-50-vh stm-background-size-cover'
                                style={{ backgroundImage: 'url("' + firstImageUrl + '")' }}
                                onClick={() => this.retailOfferOnClick(retailOffer.retailOfferId)}>
                                <Row>
                                  <Col span={18} className='stm-home-theme-two-info-content'>
                                    <span
                                      style={{
                                        fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                        color: activeTemplate.templateSetting.label.color,
                                        fontSize: activeTemplate.templateSetting.label.fontSize,
                                        lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                      }}
                                    >{titleText}</span>
                                    <br />
                                    <span
                                      style={{
                                        fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                        color: activeTemplate.templateSetting.text.color,
                                        fontSize: activeTemplate.templateSetting.text.fontSize,
                                        lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`
                                      }}
                                    >{briefDescText}</span>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          )
                        })
                      }
                    </Carousel>
                  </>
                  :
                  null
              }
            </>
            :
            null
        }
      </>
    )
  }
}

export default HomeCarouselThemeTwo;